import React from 'react';
import PropTypes from 'prop-types';
import { ButtonToolbar } from 'reactstrap';
import EditButton from '../../../common/button/EditButton';
import { SALES_TAX_PATH } from '../../../../config/paths';
import SalesTaxDeleteButton from './SalesTaxDeleteButton';

const SalesTaxToolbar = ({ salesTaxId }) => (
  <ButtonToolbar className="pull-right">
    <div>
      <EditButton path={`${SALES_TAX_PATH}/${salesTaxId}/edit`} />{' '}
      <SalesTaxDeleteButton salesTaxId={salesTaxId} />
    </div>
  </ButtonToolbar>
);

SalesTaxToolbar.propTypes = {
  salesTaxId: PropTypes.number.isRequired,
};

export default SalesTaxToolbar;
